import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from '../contexts/SubscriptionContext';
import { useAuth } from '../contexts/AuthContext';

interface RequireSubscriptionProps {
  children: React.ReactNode;
}

export const RequireSubscription: React.FC<RequireSubscriptionProps> = ({ children }) => {
  const { isOnTrial, isTrialExpired, isSubscribed } = useSubscription();
  const { user } = useAuth();

  // If user is not logged in, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user has an active subscription, allow access
  if (isSubscribed) {
    return <>{children}</>;
  }

  // If user is on trial, allow access
  if (isOnTrial) {
    return <>{children}</>;
  }

  // Allow access even if trial is expired or no subscription
  // Users can still access the dashboard but will see trial/subscription warnings
  return <>{children}</>;
}; 